import { IAlcadaDescontoPorGrupo } from "../../../Interfaces/Cobranca/AlcadaDesconto/AlcadaDescontoInterface";
import { IParcelaBoletos } from "../../../Interfaces/Cobranca/ParcelasAbertas/ParcelasAbertas";
import {
    AdicionarAlcadaDescontoService,
    AtualizarAlcadaDescontoService,
    CalculaDescontoJurosMultaService,
    ExcluirAlcadaDescontoService,
    GetAlcadaDescontoPorIdCasoControllerService,
    GetMelhorAlcadaDescontoService,
    GetMelhorAlcadaHonorarioService,
    ListarAlcadaDescontoPorGrupoService,
    VerificaNrAgingAlcadaService,
} from "../../../Services/Cobranca/AlcadaDesconto/AlcadaDescontoService";
import { Controller } from "../../Controller";

export async function GetMelhorAlcadaHonorarioController(idCaso: number) {
    return Controller(GetMelhorAlcadaHonorarioService(idCaso));
}

export async function GetMelhorAlcadaDescontoController(idCaso: number) {
    return Controller(GetMelhorAlcadaDescontoService(idCaso));
}

export async function GetAlcadaDescontoPorIdCasoController(idCaso: number) {
    return Controller(GetAlcadaDescontoPorIdCasoControllerService(idCaso));
}

export async function VerificaNrAgingAlcadaController(
    NR_INICIO_AGING: number,
    NR_FIM_AGING: number,
    idConta: number,
    idCaso: number
) {
    return Controller(
        VerificaNrAgingAlcadaService(
            NR_INICIO_AGING !== null ? NR_INICIO_AGING : 0,
            NR_FIM_AGING !== null ? NR_FIM_AGING : 0,
            idConta,
            idCaso
        )
    );
}

export async function CalculaDescontoJurosMultaController(
    parcelas: Array<IParcelaBoletos>,
    idCaso: number,
    valDescontoJuros: number,
    valDescontoMulta: number,
    valHonorarioP: number,
    valDescontoVlPrincipal: number
) {
    return Controller(
        CalculaDescontoJurosMultaService(
            parcelas,
            idCaso,
            valDescontoJuros,
            valDescontoMulta,
            valHonorarioP,
            valDescontoVlPrincipal
        )
    );
}

export async function ListarAlcadaDescontoPorGrupoController(
    requestBody: IAlcadaDescontoPorGrupo
) {
    return Controller(ListarAlcadaDescontoPorGrupoService(requestBody));
}

export async function AdicionarAlcadaDescontoController(
    requestBody: IAlcadaDescontoPorGrupo
) {
    return Controller(AdicionarAlcadaDescontoService(requestBody));
}

export async function ExcluirAlcadaDescontoController(
    idAlcadaDesconto: number
) {
    return Controller(ExcluirAlcadaDescontoService(idAlcadaDesconto));
}

export async function AtualizarAlcadaDescontoController(
    requestBody: IAlcadaDescontoPorGrupo
) {
    return Controller(AtualizarAlcadaDescontoService(requestBody));
}
